export default __webpack_public_path__ + "static/media/512.a885ee93.png";